import type { SugarmateError } from "@tandemdiabetes/sugarmate-api-react-client"
import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { useMemo } from "react"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  code?: SugarmateError["code"];
  status?: SugarmateError["status"];
}

export function ResendInvitationErrorToast(props: Props) {
  const {
    id, code, status: statusCode,
  } = props

  const polyglot = usePolyglot()

  const body = useMemo(
    () => {
      switch (code) {
        case 1001: // max followers exceeded
          return polyglot.t("toasts.follow_invitation_resend_error.max_followers_body")
        case 1006: // rate limit exceeded
          return polyglot.t("toasts.follow_invitation_resend_error.rate_limit_body")
        default:
          if (statusCode === 429) {
            return polyglot.t("toasts.follow_invitation_resend_error.rate_limit_body")
          }
          return polyglot.t("error_messaging.generic_error")
      }
    },
    [
      code,
      polyglot,
      statusCode,
    ],
  )

  return (
    <Toast
      stylePreset="error"
      body={body}
      id={id}
    />
  )
}